<nav class="breadcrumb" [attr.aria-label]="'breadcrumbs.ariaLabel' | transloco">
  <ol class="breadcrumb__list">
    <li class="breadcrumb__item" *ngFor="let item of items; let last = last; let first = first">
      <i *ngIf="!first" class="fas fa-chevron-right breadcrumb__sep" aria-hidden="true"></i>
      <a
        *ngIf="!last && item.link"
        class="breadcrumb__link"
        [routerLink]="languageRoutingService.getLocalizedRoute(item.link)">{{ item.labelKey | transloco }}</a>
      <span
        *ngIf="last || !item.link"
        class="breadcrumb__current"
        [attr.aria-current]="last ? 'page' : null">{{ item.labelKey | transloco }}</span>
    </li>
  </ol>
</nav>
